import { mangaList } from "@/mocks/manga";

export default function Latest() {
  return (
    <section id="latest" className="bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/15 px-4 py-1.5 text-sm font-medium text-accent-600">
              <i className="ri-time-line"></i>
              实时更新
            </span>
            <h2 className="mt-4 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              最新更新
            </h2>
            <p className="mt-3 max-w-xl text-base text-foreground-700">
              热门作品每日高能连载，第一时间捕捉最新话剧情。
            </p>
          </div>
          <a
            href="#subscribe"
            className="inline-flex items-center gap-2 rounded-full border border-primary-500/50 px-5 py-2.5 text-sm font-medium text-primary-500 transition-colors hover:bg-primary-500 hover:text-background-50 whitespace-nowrap"
          >
            <i className="ri-notification-3-line"></i>
            订阅更新提醒
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {mangaList.map((m) => (
            <article
              key={m.id}
              className="group flex gap-4 rounded-xl border border-background-200/70 bg-background-50 p-4 transition-colors hover:border-primary-500/50"
            >
              <div className="relative h-32 w-24 shrink-0 overflow-hidden rounded-lg">
                <img
                  src={m.cover}
                  alt={`${m.name}漫画封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="flex min-w-0 flex-1 flex-col">
                <h3 className="truncate font-heading text-base font-bold text-foreground-950 group-hover:text-primary-500">
                  {m.name}
                </h3>
                <p className="mt-1 truncate text-sm text-foreground-600">{m.chapter}</p>
                <span className="mt-2 inline-flex w-fit items-center gap-1 rounded-full bg-primary-500/10 px-2 py-0.5 text-xs text-primary-500">
                  <i className="ri-arrow-right-up-line"></i>
                  {m.updated}
                </span>
                <a
                  href="#subscribe"
                  className="mt-auto inline-flex items-center gap-1 pt-2 text-sm font-medium text-primary-500 hover:text-primary-400"
                >
                  立即观看 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}